export default __webpack_public_path__ + "static/timesheet-32517f730b4b42cd2c2f047ea1090806.svg";